// react
import { Suspense } from 'react';

// tanstack
import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';

// shared components
import { ServiceGuard } from '@/components/access-control/ServiceGuard';

export const Route = createFileRoute(
  '/$accountId/_user/eforsyning-integration',
)({
  component: () => (
    <ServiceGuard
      serviceNames={['EforsyningIntegration']}
      fallback={<Navigate to="/$accountId" />}
    >
      <Suspense>
        <Outlet />
      </Suspense>
    </ServiceGuard>
  ),
  staticData: { crumb: 'eforsyning-integration:overviewTitle' },
});
